<template>
  <div>
    <el-dialog title="用户提现"
      class="withdraw-dialog"
      v-on="$listeners"
      v-bind="$attrs"
      :append-to-body="true"
      :modal-append-to-body="false"
      @close="handleClose">
      <el-form label-width="100px" v-if="withdrawParam.info">
        <el-form-item label="申请人">
          {{ withdrawParam.info.telephone + (withdrawParam.info.alias_name ? `[${withdrawParam.info.alias_name}]` : "") }}
        </el-form-item>
        <el-form-item label="支付宝账号">
          {{ payinfoFormat(withdrawParam.info).account}}( {{payinfoFormat(withdrawParam.info).name}} )
        </el-form-item>
        <el-form-item label="发放类型">
          <el-select v-model="formData.type">
            <el-option :value="2" label="支付宝发放" :disabled="!autoTransferStatus.all"></el-option>
            <el-option :value="1" label="自行发放"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加备注">
          <zt-input v-model="formData.remark" type="text" width="460px"></zt-input>
        </el-form-item>
        <el-form-item label="总计">
          <div class="amount">¥{{withdrawParam.info.money}}</div>
        </el-form-item>
        <el-form-item>
          <zt-button type="primary" width="120px" @click="handleWithdrawConfirm" :loading="loadingWithdrawApply">确定</zt-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { withdrawTypeMap } from '../withdraw.const'
import {payinfoFormat} from '../withdraw.utils'
import {taoke_commission_withdraw_apply_confirm} from '@/api/finance'

export default {
  props: {
    withdrawParam: Object,
    autoTransferStatus: Object,
  },
  data: () => ({
    formData: {
      type: withdrawTypeMap['自行发放'],
      remark: '',
    },
    loadingWithdrawApply: false, // 提现确定loading
  }),
  methods: {
    payinfoFormat,

    // 关闭
    handleClose() {
      this.$emit('update:visible', false)
    },

    handleOpen() {
      Object.assign(this.$data, this.$options.data())
      if(this.autoTransferStatus.all) {
        this.formData.type = withdrawTypeMap['支付宝发放']
      }
    },
    // 提现确定
    async handleWithdrawConfirm() {
      this.loadingWithdrawApply = true
      const {data} = await taoke_commission_withdraw_apply_confirm({
        id: this.withdrawParam.info.id,
        agree: 1,
        ...this.formData,
      })
      this.loadingWithdrawApply = false
      this.$requestResultMessage(data, '支付成功');
      this.$emit('refresh-list')
      this.handleClose()
    },
  },
}
</script>

<style lang="scss" scoped>
.withdraw-dialog {
  .amount {
    color: $theme-orange;
    font-weight: bold;
    font-size: 18px !important;
  }
  .zt-input {
    max-width: 100%;
  }
}
</style>
